import { gql } from "@apollo/client";

//queries

export const QUERY_COMPANY_BRANCHES = gql`
  query ($operatorId: ID!, $selectedPartnerCompany: ID) {
    searchBranches(
      operatorId: $operatorId
      partnerId: $selectedPartnerCompany
    ) {
      partnerBranchId
      partnerBranch
    }
  }
`;

export const QUERY_COMPANY_NKCNAME = gql`
  query ($operatorId: ID!) {
    partners(operatorId: $operatorId) {
      partnerId
      companyNickname
    }
  }
`;

export const QUERY_LOCKER_TYPE = gql`
  query {
    lockerTypes {
      lockerTypeId
      lockerType
    }
  }
`;

export const QUERY_SUSPICIOUS_NUMBERS = gql`
  query ($recipientMobile: String, $partnerAgentId: String) {
    suspiciousAgents(
      recipientMobile: $recipientMobile
      partnerAgentId: $partnerAgentId
    ) {
      partnerAgentSuspiciousId
      partnerAgentId
      recipientMobile
      reason
      firstName
      lastName
      createdAt
      updatedAt
      agentStatus
      agentMobile
      agentStatusComment
      relatedSuspiciousMobiles {
        agentMobile
        partnerAgentSuspiciousMobileId
        createdAt
        updatedAt
      }
      __typename
    }
  }
`;

export const MUTATION_UPSERT_SUSPICIOUS_NUMBERS = gql`
  mutation UpsertCourierAgentSuspicious($input: CourierAgentSuspiciousInput!) {
    upsertPartnerAgentSuspicious(input: $input) {
      partnerAgentSuspicious {
        partnerAgentSuspiciousId
        partnerAgentId
        recipientMobile
        reason
        createdAt
        updatedAt
      }
    }
  }
`;

export const MUTATION_DELETE_SUSPICIOUS_NUMBERS = gql`
  mutation ($partnerAgentSuspiciousId: Int!) {
    deletePartnerAgentSuspicious(
      partnerAgentSuspiciousId: $partnerAgentSuspiciousId
    ) {
      success
    }
  }
`;

export const QUERY_LOCKER_NAME = gql`
  query ($operatorId: ID!, $selectedLockerType: Int) {
    lockers(operatorId: $operatorId, lockerTypeId: $selectedLockerType) {
      lockerName
      lockerId
    }
  }
`;

export const QUERY_DROP_OFF_STATUS_HISTORY = gql`
  query (
    $operatorId: ID!
    $dateStart: Date!
    $dateEnd: Date!
    $selectedStatus: [Int]
    $selectedLockerName: [Int]
    $selectedPartnerCompany: ID
    $selectedPartnerBranch: [Int]
    $partnerAgentId: ID
  ) {
    packageDropoffStatusHistory(
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
      packageStates: $selectedStatus
      lockerIds: $selectedLockerName
      partnerId: $selectedPartnerCompany
      partnerBranchIds: $selectedPartnerBranch
      period: "daily"
      partnerAgentId: $partnerAgentId
    ) {
      packageId
      locker
      waybill
      recipient
      dropoff
      status
      statusDate
      elapsedHrs
      courier
      history
      partner
      userId
      userAccountId
      agentId
      __typename
    }
  }
`;

export const QUERY_REMOVAL_RATE = gql`
  query ($operatorId: ID!, $dateStart: Date!, $dateEnd: Date!) {
    packageDropoffStatusHistory(
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
      packageStates: "118"
    ) {
      userAccountId
      agentId
      locker
    }
  }
`;

export const QUERY_Wallet_Operator = gql`
  query ($operatorId: Int) {
    operators(operatorId: $operatorId) {
      company
      operatorRole {
        accessPermissions
      }
    }
  }
`;

export const QUERY_Wallet_Partners = gql`
  query ($operatorId: ID!) {
    searchCouriers(operatorId: $operatorId) {
      partnerId
      companyNickname
    }
  }
`;

export const QUERY_Wallet_Branches = gql`
  query ($operatorId: ID!) {
    branches(operatorId: $operatorId) {
      partnerBranch
      partnerBranchId
    }
  }
`;

export const QUERY_Wallet_Agents = gql`
  query ($operatorId: ID!) {
    agents(operatorId: $operatorId) {
      agentName
      partnerAgentId
      firstName
      lastName
    }
  }
`;
export const QUERY_WALLET_CHOICES = gql`
  query ($operatorId: ID!, $accountTypeNo: Int!) {
    wallet2(accountTypeNo: $accountTypeNo, operatorId: $operatorId) {
      ... on OperatorType {
        company
        loadBalance
      }
      ... on PartnerType2 {
        partnerId
        companyNickname
        loadBalance
      }
      ... on PartnerBranchType {
        partnerBranchId
        partnerBranch
        loadBalance
      }
      ... on PartnerAgentType {
        agentName
        partnerAgentId
        loadBalance
        firstName
        lastName
      }
    }
  }
`;

export const MUTATION_WALLET_UPDATE = gql`
  mutation ($input: AdjustBalanceInput!) {
    adjustBalance(input: $input) {
      sourceBalance
      destinationBalance
    }
  }
`;

export const NEW_WALLET_MUTATION = gql`
  mutation (
    $amount: Decimal!
    $destinationAccountId: Int!
    $destinationAccountTypeNo: Int!
    $sourceAccountId: Int!
    $sourceAccountTypeNo: Int!
    $walletTypeNo: Int!
  ) {
    transferAmount(
      amount: $amount
      destinationAccountId: $destinationAccountId
      destinationAccountTypeNo: $destinationAccountTypeNo
      sourceAccountId: $sourceAccountId
      sourceAccountTypeNo: $sourceAccountTypeNo
      walletTypeNo: $walletTypeNo
    ) {
      success
      message
    }
  }
`;

export const NEWEST_WALLET_TOP_UP_QUERY = gql`
  query ($walletTypeNo: Int!, $accountTypeNo: Int!, $accountId: Int!) {
    wallet3(
      walletTypeNo: $walletTypeNo
      accountTypeNo: $accountTypeNo
      accountId: $accountId
    ) {
      walletId
      walletName
      walletStatus
      walletTypeNo
      accountTypeNo
      accountId
      walletBalance
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const QUERY_CHART_DATA = gql`
  query (
    $operatorId: ID!
    $selectedRadio: String
    $dateStart: Date!
    $dateEnd: Date!
    $selectedStatus: [Int]
    $selectedLockerName: [Int]
    $selectedPartnerCompany: ID
    $selectedPartnerBranch: [Int]
  ) {
    packageDropoffStatus(
      operatorId: $operatorId
      period: $selectedRadio
      dateStart: $dateStart
      dateEnd: $dateEnd
      packageStates: $selectedStatus
      lockerIds: $selectedLockerName
      partnerId: $selectedPartnerCompany
      partnerBranchIds: $selectedPartnerBranch
    ) {
      date
      packages
      statusPending
      statusRemoved
      statusOverstay
      statusClaimed
      statusTakeback
      statusRevoked
      __typename
    }
  }
`;

export const QUERY_Unrecognized_Waybill = gql`
  query (
    $operatorId: ID!
    $dateStart: Date!
    $dateEnd: Date!
    $selectedStatus: [Int]
    $selectedLockerName: ID
    $selectedPartnerCompany: ID
    $selectedPartnerBranch: ID
    $partnerAgentId: ID
  ) {
    unrecognizedWaybill(
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
      packageStates: $selectedStatus
      lockerId: $selectedLockerName
      partnerId: $selectedPartnerCompany
      partnerBranchId: $selectedPartnerBranch
      period: "daily"
      partnerAgentId: $partnerAgentId
    ) {
      packageId
      locker
      waybill
      recipient
      dropoff
      status
      statusDate
      elapsedHrs
      courier
      history
      partner
      userId
      userAccountId
      agentId
      __typename
    }
  }
`;
